import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { CustomModal, InputText, CustomCheckbox, Btn } from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useBalancaModal, { LOAD_MESSAGE } from './BalancaModalHook'

function BalancaModal({ show, data, onModalClose, onModalSave, selectedTp, dispatch }) {
  const { state, localDispatch } = useBalancaModal()

  useEffect(() => {
    localDispatch.start(data)
  }, [data])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.SAVE:
        dispatch(showLoadingBox('Salvando balança', 'Aguarde...'))
        localDispatch
          .save(selectedTp)
          .then(saved => {
            dispatch(hideLoadingBox())
            onModalSave(saved)
            localDispatch.reset()
          })
          .catch(() => {})
        break
      case LOAD_MESSAGE.SUCCESS:
        dispatch(showMessageBox('Balança salva com sucesso', null))
        dispatch(hideLoadingBox())
        localDispatch.reset()
        break
      default:
        break
    }
  }, [state.loadingMessage, selectedTp])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.reset()
    }
  }, [state.errorMessage])

  return (
    <CustomModal header="Balança" isVisible={show} onClose={onModalClose} width={500}>
      <div className="p-grid">
        <div className="p-col-8">
          <InputText
            label="Nome:*"
            value={state.balanca.name || ''}
            onChange={v => localDispatch.onChange('name', v || '')}
          />
        </div>
        <div className="p-col-4" style={{ display: 'flex', alignItems: 'flex-end' }}>
          <CustomCheckbox
            checked={!!state.balanca.actived}
            onChange={v => localDispatch.onChange('actived', !!v)}
          >
            Ativa
          </CustomCheckbox>
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Btn onClick={() => localDispatch.onBtnSalvarClicked(selectedTp)}>Salvar</Btn>
      </div>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(BalancaModal)
